import { etagFetch } from './etagFetch';
import { getEnvironment } from './environment';

export type SchedulerItem = {
  startDate: string;
  endDate: string;
  theme: string;
};

export type Theme = {
  tailwind?: {
    [colorKey: string]: string;
  };
  antd?: {
    light: Record<string, any>;
    dark: Record<string, any>;
  };
};

export type Themes = {
  [themeName: string]: Theme;
};

export type RemoteTheme = {
  scheduler: SchedulerItem[];
  themes: Themes;
};

export const REMOTE_THEME_URL = 'https://cdn.eduzzcdn.com/theme';
export const THEME_REFRESH_MINUTES_INTERVAL = 60;
const THEME_ETAG_STORAGE_KEY = 'eduzz-ui-remote-theme-etag';
const THEME_VALUE_STORAGE_KEY = 'eduzz-ui-remote-theme-value';

const ENV_FILENAMES: Record<'prod' | 'dev' | 'qa', string> = {
  prod: 'theme.json',
  dev: 'theme_dev.json',
  qa: 'theme_qa.json'
};

export const getCurrentTheme = (remoteTheme: RemoteTheme) => {
  const urlParams = new URLSearchParams(window.location.search);
  const themeFromUrl = urlParams.get('remoteTheme');

  if (themeFromUrl && remoteTheme.themes[themeFromUrl]) {
    return themeFromUrl;
  }

  const now = new Date();
  const active = remoteTheme.scheduler.find(item => {
    const start = new Date(item.startDate);
    const end = new Date(item.endDate);
    return now >= start && now <= end;
  });

  return active ? active.theme : 'default';
};

export const fetchRemoteTheme = async (): Promise<RemoteTheme | undefined> => {
  const filename = ENV_FILENAMES[getEnvironment()];

  return etagFetch<RemoteTheme>({
    url: `${REMOTE_THEME_URL}/${filename}`,
    etagStorageKey: THEME_ETAG_STORAGE_KEY,
    valueStorageKey: THEME_VALUE_STORAGE_KEY
  });
};
